module.exports = __webpack_public_path__ + "img/23.67122d0c.jpg";